import * as yup from 'yup';
import TranslationHelper from '@/app/helpers/TranslationHelper';
import { FIELD_REQUIRED } from '@/app/constants/yup';

// Single assignment validation schema
const assignmentSchema = yup.object({
    name: yup
        .string()
        .required(() => TranslationHelper.translate(FIELD_REQUIRED)),
    typeId: yup
        .number()
        .required(() => TranslationHelper.translate(FIELD_REQUIRED)),
    templateId: yup
        .number()
        .required(() => TranslationHelper.translate(FIELD_REQUIRED)),
});

export const validationSchema = yup
    .object()
    .test('assignments-shape', '', function (value) {
        const obj = value as Record<string, unknown>;
        const keys = Object.keys(obj);
        const errors = [];

        for (const key of keys) {
            const assignment = obj[key];
            const cast = assignmentSchema.cast(assignment, {
                stripUnknown: true,
            });

            const nameValid = yup
                .reach(assignmentSchema, 'name')
                .isValidSync(cast?.name);
            if (!nameValid) {
                errors.push(
                    new yup.ValidationError(
                        TranslationHelper.translate(FIELD_REQUIRED),
                        cast?.name,
                        `reports.${key}.name`
                    )
                );
            }

            const typeValid = yup
                .reach(assignmentSchema, 'typeId')
                .isValidSync(cast?.typeId);
            if (!typeValid) {
                errors.push(
                    new yup.ValidationError(
                        TranslationHelper.translate(FIELD_REQUIRED),
                        cast?.typeId,
                        `reports.${key}.typeId`
                    )
                );
            }

            const templateValid = yup
                .reach(assignmentSchema, 'templateId')
                .isValidSync(cast?.templateId);
            if (!templateValid) {
                errors.push(
                    new yup.ValidationError(
                        TranslationHelper.translate(FIELD_REQUIRED),
                        cast?.templateId,
                        `reports.${key}.templateId`
                    )
                );
            }
        }

        if (errors.length > 0) {
            throw new yup.ValidationError(errors);
        }

        return true;
    });
